import React, { useContext, useEffect, useRef, useState } from 'react';
import JobRequests from './JobRequests';

import { getNextPickupTime, getSelectedTabListPickupView, getSelectedTabListView, getUserData, setNextPickupTime, setSelectedTabListPickupView, setSelectedTabListView } from '../../utils/localStorage';
import { useLocation, useNavigate } from 'react-router-dom';
import SuccessModal from '../SuccessModal';
import StatusFilterModal from '../StatusFilterModal';
import TabMenu from '../TabMenu';
import StoreMenu from '../StoreMenu';
import { postStoreRiderJobPickupOrDelivery } from '../../services/StoreRiderInfo/StoreRiderInfo';
import ButtonLink from '../../ButtonLink';
import { getStoreNewPick } from '../../services/DashboardAPI/DashboardApi';
import { Toast } from 'primereact/toast';
import PickupNotification from "../../assets/sounds/pickup-notification.mp3"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import JobRequestsListView from './JobRequestsListView';
import RiderPickupDeliveryOrderBookingModal from '../RiderPickupDeliveryOrderBookingModal';
import { ProgressSpinner } from 'primereact/progressspinner';
import { localeDateEndDate, localeDateStartDate } from '../../constants/DateUtil/DateUtil';
import SchedularModalPickupDelivery from '../SchedularModalPickupDelivery';

const { innerWidth: width, innerHeight: height } = window;

const PickupJob = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();
  const location = useLocation();

  const storeId = storeData.id;
  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;
  const enabledRiderPartialBooking = storeData.enabledRiderPartialBooking;

  const { navigateThrough } = location.state || {};

  const [visible, setVisible] = useState(false);

  const jobType = 'pickup';

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  const [startDate, setStartDate] = useState(new Date(initialStartDate));

  let initialEndDate = new Date();
  initialEndDate.setDate(initialEndDate.getDate() + 30); // subtract 7 days to current date
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const [modalVisible, setModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state for loading indicator
  const [isGetJobButtonPressed, setIsGetJobButtonPressed] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('ALL');

  const [riderPickupDeliveryOrderBookingModalVisible, setRiderPickupDeliveryOrderBookingModalVisible] = useState(false);

  const minimumDate = new Date();
  minimumDate.setMonth(minimumDate.getMonth()); // subtract 3 months to current date

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const [todayOrderData, setTodayOrderData] = useState([]);
  const [orderBookedType, setOrderBookedType] = useState("")

  const [schedularModalPickupDeliveryVisible, setSchedularModalPickupDeliveryVisible] = useState(false)
  const [schedularDate, setSchedularDate] = useState({});

  const handleCalendarModal = () => {
    setSchedularModalPickupDeliveryVisible(true);
  };

  const [tabularView, setTabularView] = useState(false);
  
    const handleTabListViewChange = async (selectedType) => {
      setTabularView(selectedType);
      await setSelectedTabListPickupView(selectedType);
    };

    const fetchSelectedTabListView = async () => {
        try {
          const selectedInvoiceTypeData = await getSelectedTabListPickupView();
          setTabularView(selectedInvoiceTypeData?.tabListPickupView || "list");
        } catch {
          setTabularView("list");
        }
      };

  const fetchRiderJobPickupData = data => {
    postStoreRiderJobPickupOrDelivery(storeId, jobType, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          const FilterData = Res?.filter((item) => item?.pickupRequest?.requestForBooking === false)
          setTodayOrderData(FilterData);
        }
      })
      .catch(err => {
        console.error('Rider Job Error:', err);
      });
  };

  const toast = useRef(null);
  const audioRef = useRef(null);
  const hasNotifiedRef = useRef(false);

  const showInfo = (data) => {
    toast.current?.show({
      severity: "info",
      summary: "Notification",
      detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
      life: 10000,
    });

    // 🔊 Play sound
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // restart sound
      audioRef.current.play().catch(() => {
        // autoplay might be blocked until user interaction
      });
    }
  };

  //  useEffect(() => {
  //    const unlockAudio = () => {
  //      if (audioRef.current) {
  //        audioRef.current.play().then(() => {
  //          audioRef.current.pause();
  //          audioRef.current.currentTime = 0;
  //        });
  //      }
  //      document.removeEventListener("click", unlockAudio);
  //    };

  //    document.addEventListener("click", unlockAudio);

  //    return () => document.removeEventListener("click", unlockAudio);
  //  }, []);

  const fetchStoreNewPick = async () => {
    try {
      const response = await getStoreNewPick(storeId);

      if (!response.data.error) {
        if (response.data > 0 && !hasNotifiedRef.current) {
          showInfo(response.data);
          hasNotifiedRef.current = true;
        }

        // reset when no pickup exists
        if (response.data === 0) {
          hasNotifiedRef.current = false;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (enabledNewPickupStoreNotified) {

      // Initialize timer if not present
      if (!getNextPickupTime()) {
        setNextPickupTime();
      }

      const interval = setInterval(() => {
        const nextTime = getNextPickupTime();
        const now = Date.now();

        if (now >= nextTime) {
          // ⏰ Time is zero → call API
          fetchStoreNewPick();

          // 🔄 Reset timer
          setNextPickupTime();
        }
      }, 1000); // check every second

      return () => clearInterval(interval);
    }
  }, [enabledNewPickupStoreNotified]);

  //  useEffect(() => {
  //    const interval = setInterval(() => {
  //      fetchStoreNewPick();
  //    }, 15000); // 15 seconds

  //    return () => clearInterval(interval);
  //  }, []);


  useEffect(() => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        'PICKUP_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
      ],
    };
    fetchRiderJobPickupData(data);
    fetchSelectedTabListView();
  }, []);

  const callRequestApi = () => {
    const data = {
      startDate: localeDateStartDate(new Date(startDate)),
      endDate: localeDateEndDate(new Date(endDate)),
      jobStatus: [
        'PICKUP_REQ',
        'ASSIGNED_TO_RIDER',
        'RESCHEDULE_BY_CUSTOMER',
        'RESCHEDULE_BY_RIDER',
      ],
    };
    fetchRiderJobPickupData(data);
    fetchSelectedTabListView();
  };


  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const handleFilterOrderBookedModal = () => {
    setRiderPickupDeliveryOrderBookingModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const receiveDataFromStatusFilterModal = selectedStatus => {
    handleConfirmPickup(selectedStatus);
  };

  const receiveDataFromOrderBookedFilterModal = newSchedular => {
    handleConfirmPickup(newSchedular);
    setOrderBookedType("ORDER_BOOKED");
  };

  const receiveDataFromSchedularModalPickupDelivery = newSchedular => {
    setSchedularDate(newSchedular);
    handleConfirmPickup(newSchedular);
  };

  const handleConfirmPickup = (selectedStatus) => {
    setIsLoading(true);

    if (!isGetJobButtonPressed) {
      setIsGetJobButtonPressed(true);

      setTimeout(() => {
        setIsLoading(false);

        const rawStart = selectedStatus?.newSchedular?.startDate;
        const rawEnd = selectedStatus?.newSchedular?.endDate;

        const resolvedStartDate = rawStart
          ? localeDateStartDate(new Date(rawStart))
          : localeDateStartDate(new Date(startDate));

        const resolvedEndDate = rawEnd
          ? localeDateEndDate(new Date(rawEnd))
          : localeDateEndDate(new Date(endDate));

        const defaultStatusList = [
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ];

        // Figure out jobStatus based on which shape selectedStatus came in as
        let jobStatus;

        if (Array.isArray(selectedStatus)) {
          // From receiveDataFromStatusFilterModal: already an array of statuses
          jobStatus = selectedStatus;
        } else if (selectedStatus?.newSchedular?.selectedStatus) {
          // From receiveDataFromOrderBookedFilterModal (e.g. "ORDER_BOOKED")
          jobStatus = [selectedStatus.newSchedular.selectedStatus];
        } else if (selectedStatus === 'ALL') {
          // Explicit "ALL" string
          jobStatus = defaultStatusList;
        } else {
          // From receiveDataFromSchedularModalPickupDelivery: dates only, no status
          jobStatus = defaultStatusList;
        }

        const requestData = {
          startDate: resolvedStartDate,
          endDate: resolvedEndDate,
          jobStatus,
        };

        fetchRiderJobPickupData(requestData);

        setIsGetJobButtonPressed(false);
        fetchSelectedTabListView();

        // Reset the form fields
        const resetDate = new Date();
        setStartDate(resetDate);
        setEndDate(resetDate);
      }, 1000); // Replace with actual async operation duration
    }
  };
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i className="pi pi-angle-left" onClick={() => navigateThrough ? navigate("/RiderJobs") : navigate(-1)} style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold ">
                Pickup Job
              </p>
            </div>
          </div>

          {enabledRiderPartialBooking && <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              navigate("/store-partial-booking")
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#e064ff",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                Partial Booking
              </p>
            </div>
          </div>}

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              tabularView !== "tab"
                ? handleTabListViewChange("tab")
                : handleTabListViewChange("list");
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#22C55E",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                {tabularView !== "tab" ? "Tab View" : "List View"}
              </p>
            </div>
          </div>

          

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => {
              handleFilterOrderBookedModal();
            }}
          >
            <div
              className="px-3 py-1 cursor-pointer"
              style={{
                backgroundColor: "#ff6464",
                borderRadius: 5,
                marginRight: 20,
              }}
            >
              <p className=" text-lg text-white font-medium capitalize">
                Closed Pickup
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
            />
          </div>

          <div
            onClick={() => handleFilterModal("DELIVERED")}
            className="mx-2 cursor-pointer"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
              style={{ width: height < 600 ? 25 : 30 }}
            />
          </div>


          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "30px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>




      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={'Added'}
        text={'Your Amount is added successfully.'}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ]}
      />

      <SchedularModalPickupDelivery
        setSchedularModalPickupDeliveryVisible={setSchedularModalPickupDeliveryVisible}
        schedularModalPickupDeliveryVisible={schedularModalPickupDeliveryVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModalPickupDelivery}
      />

      <RiderPickupDeliveryOrderBookingModal
        setRiderPickupDeliveryOrderBookingModalVisible={setRiderPickupDeliveryOrderBookingModalVisible}
        riderPickupDeliveryOrderBookingModalVisible={riderPickupDeliveryOrderBookingModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromOrderBookedFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={[
          'PICKUP_REQ',
          'ASSIGNED_TO_RIDER',
          'RESCHEDULE_BY_CUSTOMER',
          'RESCHEDULE_BY_RIDER',
        ]}
      />

      <div>
        {tabularView === "tab" && (
          <div
            className="scroll-bar mb-2"
            style={{
              height: height - 80,
              overflowY: "scroll",
            }}
          >
            {isLoading ? (
                    <div style={{ flex: 1 }}>
                      <div className="text-center">
                        <ProgressSpinner
                          style={{ width: "70px", height: "70px" }}
                          strokeWidth="4"
                          fill="var(--surface-ground)"
                          animationDuration="2s"
                        />
                      </div>
                    </div>) : (

                      <JobRequestsListView
                      orderInfoData={todayOrderData}
                      JobType={jobType}
                      storeId={storeId}
                      callRequestApi={callRequestApi}
                      pickupType={orderBookedType}
                      />
                    ) }
          </div>
        )}
      </div>
      <div style={{ display: tabularView === "tab" ? "none" : "" }}>
      <JobRequests
        orderInfoData={todayOrderData}
        JobType={jobType}
        storeId={storeId}
        callRequestApi={callRequestApi}
      />
      </div>

      {/* <TabMenu  /> */}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <audio
        ref={audioRef}
        preload="auto"
        // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
        src={PickupNotification}
      />
      <div className="flex justify-content-center">
        <Toast ref={toast} />
      </div>
    </div>
  );
};

export default PickupJob;